// export const BASE_URL = 'http://localhost:5000/api'

export const BASE_URL = 'https://diraholidaysbackend.onrender.com/api'
